import React, { Component, PropTypes as pt } from 'react';
import moment from 'moment';

class SelectInput extends Component {
    constructor (props) {
        super(props);

        this.state = {
            value: props.value,
            edited: false
        };
    }

    componentWillReceiveProps (nextProps) {
        if (this.state.edited) {
            this.setState({
                edited: false,
                value: nextProps.value
            });
        }
    }

    render () {
        const { preferenceName, options } = this.props;
        const value = (this.state.edited) ?
            this.state.value :
            this.props.value

        const renderedOptions = options.map(function (opt, k) {

            let value = (preferenceName == 'dateFormat') ? moment().format(opt) : opt;

            return (<option key={k} value={opt}>
                {typeof value === 'string' ? value.capitalizeWord() : value}
            </option>);
        });

        return <select
            value={value}
            name={preferenceName}
            className="form-control"
            onChange={function (ev) {
                let value = ev.target.value;
                this.setState({
                    value: value,
                    edited: true
                });
                this.props.storeEdits(value);
            }.bind(this)}>
                {renderedOptions}
        </select>;
    }
}

SelectInput.propTypes = {};

export default SelectInput;
